import { Component, OnInit, afterNextRender } from '@angular/core';
import { PagingNavItem } from '@hrra/core';
import { AnnouncementInviteResponseEnum, AnnouncementInviteViewStatusEnum, AnnouncementStatusEnum } from '@hrra/common-models';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { AppState } from 'src/app/root-store/state';
import { loadInvites } from 'src/app/root-store/jobseeker-store/jobseeker-applies/actions';
import {
  selectInviteFilter,
  selectInviteItems,
  selectInviteStats,
  selectInvitesCurrentPage,
  selectInvitesDisplayPages,
  selectInvitesIsLoading,
  selectInvitesPageCount,
} from 'src/app/root-store/jobseeker-store/jobseeker-applies/selectors';
import { JobseekerInviteItemViewModel, JobseekerInviteStatsViewModel } from '../shared/models/jobseeker-invite-model';
import { JobseekerInviteFilterEnum } from '../shared/models/enums/invite-list-filter-enum';

interface FilterChip {
  key: JobseekerInviteFilterEnum;
  labelKey: string;
  statsKey: keyof JobseekerInviteStatsViewModel;
}

@Component({
    selector: 'app-jobseeker-invite-list',
    templateUrl: './jobseeker-invite-list.component.html',
    styleUrls: ['./redesign/jobseeker-invite-list.component.scss'],
    standalone: false
})
export class JobseekerInviteListComponent implements OnInit {

  public invites$: Observable<JobseekerInviteItemViewModel[]>;
  public inviteStats$: Observable<JobseekerInviteStatsViewModel>;
  public activeFilter$: Observable<JobseekerInviteFilterEnum>;
  public pageCount$: Observable<number>;
  public navItems$: Observable<PagingNavItem[]>;
  public currentPage$: Observable<number>;
  public isLoading$: Observable<boolean>;

  public announcementStatus = AnnouncementStatusEnum;
  public viewStatus = AnnouncementInviteViewStatusEnum;
  public responseStatus = AnnouncementInviteResponseEnum;
  public inviteFilter = JobseekerInviteFilterEnum;

  public readonly filterChips: FilterChip[] = [
    { key: JobseekerInviteFilterEnum.All, labelKey: 'label.All', statsKey: 'all' },
    { key: JobseekerInviteFilterEnum.New, labelKey: 'label.New', statsKey: 'new' },
    { key: JobseekerInviteFilterEnum.InterestedAndApplied, labelKey: 'label.InvitationStatusInterestedAndApply', statsKey: 'interestedAndApplied' },
    { key: JobseekerInviteFilterEnum.Interested, labelKey: 'label.InvitationStatusInterested', statsKey: 'interested' },
    { key: JobseekerInviteFilterEnum.NotInterested, labelKey: 'label.InvitationStatusNotInterested', statsKey: 'notInterested' },
  ];

  public readonly responseStatusLabelMap: { [key in AnnouncementInviteResponseEnum]: string } = {
    [AnnouncementInviteResponseEnum.NotResponded]: 'label.InvitationStatusNotResponded',
    [AnnouncementInviteResponseEnum.Interested]: 'label.InvitationStatusInterested',
    [AnnouncementInviteResponseEnum.InterestedAndApplied]: 'label.InvitationStatusInterestedAndApply',
    [AnnouncementInviteResponseEnum.NotInterested]: 'label.InvitationStatusNotInterested',
  };

  constructor(private store: Store<AppState>) {
    afterNextRender(() => {
      this.store.dispatch(loadInvites({ payload: { page: 1, filter: JobseekerInviteFilterEnum.All } }));
    });
  }

  ngOnInit(): void {
    this.invites$ = this.store.pipe(select(selectInviteItems));
    this.inviteStats$ = this.store.pipe(select(selectInviteStats));
    this.activeFilter$ = this.store.pipe(select(selectInviteFilter));
    this.pageCount$ = this.store.pipe(select(selectInvitesPageCount));
    this.navItems$ = this.store.pipe(select(selectInvitesDisplayPages));
    this.currentPage$ = this.store.pipe(select(selectInvitesCurrentPage));
    this.isLoading$ = this.store.pipe(select(selectInvitesIsLoading));
  }

  onFilterSelect(filter: JobseekerInviteFilterEnum): void {
    this.store.dispatch(loadInvites({ payload: { page: 1, filter } }));
  }

  onPagingNavigation(page: number, filter: JobseekerInviteFilterEnum): void {
    this.store.dispatch(loadInvites({ payload: { page, filter } }));
  }
}
